import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, Phone } from "@phosphor-icons/react";

const links = [
    { href: "#prestations", label: "Prestations" },
    { href: "#tarifs", label: "Tarifs" },
    { href: "#process", label: "Démarche" },
    { href: "#zones", label: "Zones" },
    { href: "#contact", label: "Contact" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = () => setScrolled(window.scrollY > 24);
        handler();
        window.addEventListener("scroll", handler, { passive: true });
        return () => window.removeEventListener("scroll", handler);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-lumos-border shadow-[0_2px_24px_-12px_rgba(10,17,40,0.18)]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 h-28 flex items-center justify-between">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
                    <img
                        src="/lumos-logo.png"
                        alt="LUMOS Audit Énergétique"
                        className="h-16 lg:h-20 w-auto object-contain"
                    />
                </a>

                <nav className="hidden lg:flex items-center gap-9">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="text-sm font-semibold text-lumos-ink/75 hover:text-lumos-blue transition-colors relative group"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-lumos-blue transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <a
                        href="tel:+33186958700"
                        data-testid="nav-phone"
                        className="flex items-center gap-2 text-sm font-semibold text-lumos-ink hover:text-lumos-blue transition-colors"
                    >
                        <Phone size={18} weight="bold" />
                        01.86.95.87.00
                    </a>
                    <a href="#contact" data-testid="nav-cta-quote" className="btn-primary text-sm !py-3">
                        Obtenir mon devis
                    </a>
                </div>

                <button
                    type="button"
                    data-testid="nav-mobile-toggle"
                    aria-label="Menu"
                    onClick={() => setOpen((v) => !v)}
                    className="lg:hidden text-lumos-ink p-2"
                >
                    {open ? <X size={26} weight="bold" /> : <List size={26} weight="bold" />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="lg:hidden bg-white border-t border-lumos-border overflow-hidden"
                        data-testid="nav-mobile-menu"
                    >
                        <div className="px-6 py-6 flex flex-col gap-4">
                            {links.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    className="text-base font-semibold text-lumos-ink py-2 border-b border-lumos-border/60"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a href="tel:+33186958700" className="text-base font-semibold text-lumos-blue py-2 flex items-center gap-2">
                                <Phone size={18} weight="bold" /> 01.86.95.87.00
                            </a>
                            <a href="#contact" onClick={() => setOpen(false)} className="btn-primary justify-center !w-full">
                                Obtenir mon devis
                            </a>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
}
